<!-- eslint-disable-next-line vue/no-v-for-template-key -->
<template>
  <!-- eslint-disable-next-line vue/no-v-for-template-key -->
  <v-container fluid>
    <v-dialog v-model="dgKolanlarıGoster" scrollable width="700">


      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Form Verileri
        </v-card-title>

        <v-card-text>


          <!-- <v-list subheader three-line>
                            <v-subheader> {{ result.formname }} Bilgileri</v-subheader>

                            <v-list-item v-for="item in selectedItem.columns" :key="item.ogeId">

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.header }}</v-list-item-title>
                                    <v-list-item-subtitle>

                                        <div v-if="item.tur == 1">
                                            <a target="_blank" :href="`../` + itemLink"
                                                v-for="(itemLink, indexLink) in item.value.split(',')"
                                                :key="itemLink">Dosya_{{
                                                    indexLink }}</a>
                                        </div>
                                        <div v-else>
                                            {{ item.value }}
                                        </div>

                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="result.onayDurumId == 4">{{ item.reddedilmeNedeni
                                    }}</v-list-item-subtitle>
                                    <v-divider></v-divider>
                                </v-list-item-content>
                            </v-list-item>


                        </v-list> -->

          <FormViewRun2 :actionVisible="false" :formSavedId="formSavedId" :edit="true">
          </FormViewRun2>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-select v-model="selectedOnayDurumId" :items="onayDurums" item-text="name" item-value="id"
            label="Onay Durumu" persistent-hint single-line></v-select>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="btnOnaylamaIslemKaydet">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="frmReport" scrollable>
      <v-card>
        <v-toolbar dark color="primary">

          <v-toolbar-title>Bilgi İhraç Ekranı</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon @click="excelAktar" v-bind="attrs" v-on="on">

                  <v-icon>mdi-database-export</v-icon>
                </v-btn>
              </template>
              <span>Excel Aktar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon @click="frmReport = false" v-bind="attrs" v-on="on">

                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Çıkış</span>
            </v-tooltip>

          </v-toolbar-items>

        </v-toolbar>

        <!-- <v-card-title class="text-h5 grey lighten-2">
          Form Verileri
        </v-card-title> -->

        <v-card-text>
          <v-row>
            <v-col>
              <kriter-onay-formu :studentInfo="studentInfo" :criteria="criteria" :form-info="formInfo"></kriter-onay-formu>
            </v-col>
            <v-col>
              <h2>Form Onay Durum Raporu</h2>

              <table>
                <thead>
                  <tr>
                    <th>Form Adı</th>
                    <th>Onay Durumu</th>

                    <th>Adet (Count)</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- template içindeki :key kaldırıldı, döngü yapısı Vue 2 uyumlu hale getirildi -->
                  <template v-for="(item, index) in ogrenciBilgileri">

                    <!-- Eğer rapor dizisi boşsa -->
                    <tr v-if="item.rapor.length === 0" :key="'empty-' + index">
                      <td class="font-bold">{{ item.name }}</td>
                      <td colspan="3" class="text-muted">Kayıtlı rapor bulunamadı.</td>
                    </tr>

                    <!-- Eğer rapor dizisi doluysa -->
                    <tr v-else v-for="(subItem, subIndex) in item.rapor" :key="'row-' + index + '-' + subIndex">
                      <!-- İlk satırda form adını birleştirerek gösteriyoruz -->
                      <td v-if="subIndex === 0" :rowspan="item.rapor.length" class="font-bold">
                        {{ item.name }}
                      </td>
                      <td>
                        <span>
                          {{ subItem.onayDurum }}
                        </span>
                      </td>
                      <!-- <td>{{ subItem.onayDurumId }}</td> -->
                      <td>{{ subItem.count }}</td>
                    </tr>

                  </template>
                </tbody>
              </table>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mb-5" outlined>
         <v-toolbar dark color="primary">

          <v-toolbar-title>    Form Verileri Filtreleme</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip bottom v-if="ogrenciBilgileri.length>0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon @click="raporAl" v-bind="attrs" v-on="on">

                  <v-icon>mdi-chart-tree</v-icon>
                </v-btn>
              </template>
              <span>Excel Aktar</span>
            </v-tooltip>


          </v-toolbar-items>

        </v-toolbar>
      <!-- <v-card-title class="headline blue-grey lighten-5 primary--text">
        <v-icon left color="primary">mdi-filter-variant</v-icon>
        Form Verileri Filtreleme
      </v-card-title> -->
      <v-card-text class="pt-4">

        <v-form ref="filterForm" @submit.prevent="fetchData">
          <v-row dense>
            <v-col cols="12" md="6">

              <v-select v-model="filters.formIds" multiple :items="forms" item-text="name" item-value="id"
                label="Formlar" persistent-hint single-line></v-select>

              <!-- <v-btn v-if="ogrenciBilgileri" color="success" @click="frmReport = true;">text</v-btn> -->
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field v-model="filters.no" label="Öğrenci / Personel Numarası" outlined dense   
                prepend-inner-icon="mdi-account-search" clearable></v-text-field>

            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center justify-end">
              <v-btn color="primary" block height="40" :loading="loading" type="submit">
                <v-icon left>mdi-magnify</v-icon>
                Sorgula
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card outlined>
      <v-card-title class="d-flex justify-space-between align-center flex-wrap">
        <div>
          <span class="headline font-weight-bold">{{ metaData.formname }}</span>
          <v-chip class="ml-2" small color="secondary" outlined v-if="metaData.groupName">
            Grup: {{ metaData.groupName }}
          </v-chip>
        </div>

        <!-- <div class="mt-2 mt-sm-0">
          <v-chip :color="metaData.loginGiris ? 'green' : 'grey'" dark small class="mr-1">
            {{ metaData.loginGiris ? 'Giriş Gerekli' : 'Anonim' }}
          </v-chip>
          <v-chip :color="metaData.onaylama ? 'indigo' : 'grey'" dark small>
            {{ metaData.onaylama ? 'Onay Süreçli' : 'Onay Gerekmiyor' }}
          </v-chip>
        </div> -->
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table :headers="headers" :items="tableRows" :loading="loading"
        loading-text="Veriler yükleniyor... Lütfen bekleyin." no-data-text="Kriterlere uygun form kaydı bulunamadı."
        class="elevation-1" :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'items-per-page-text': 'Sayfa başına satır:'
        }">
        <template v-slot:item.resim="{ item }">
          <v-avatar size="40" class="my-1">
            <v-img
              :src="item.resim || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5" size="20"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </template>

        <template v-slot:item.username="{ item }">
          <div class="font-weight-medium">{{ item.username2 }}</div>
          <div class="caption text--secondary">{{ item.username || 'Girişsiz Kullanıcı' }}</div>
        </template>
        <template v-slot:item.date="{ item }">
          <div class="font-weight-medium">{{ item.date }}</div>
          <div class="caption text--secondary">{{ item.belongingFormName }}</div>
        </template>

        <template v-slot:item.onayName="{ item }">
          <v-chip :color="getStatusColor(item.onayDurumId)" dark small>
            {{ item.onayName || 'Beklemede' }}

          </v-chip>
          <div class="caption text--secondary">{{ item.onayislemtarihi }}</div>

        </template>

        <template v-slot:item.ReddedilmeNedeni="{ item }">
          <span v-if="item.ReddedilmeNedeni" class="red--text text--darken-2 caption">
            {{ item.ReddedilmeNedeni }}
          </span>
          <span v-else class="text--disabled">-</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="blue" @click="viewDetail(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { tableToExcel } from '@/plugins/custom';
import axios from 'axios'; // API istekleri için axios varsayılmıştır.
import FormService from '@/services/FormService';
import OnayDurumService from '@/services/OnayDurumService';
import FormViewRun2 from '@/components/FormViewRun2.vue';

import KriterOnayFormu from '@/components/KriterOnayFormu.vue';
export default {
  name: 'EbeFormReport',

  components: { FormViewRun2, KriterOnayFormu },
  data() {
    return {
      loading: false,
      frmReport: false,
      dgKolanlarıGoster: false,
      selectedOnayDurumId: null,
      forms: [
        { id: "e9d46ae0-5c3b-49fe-b1f5-a7d603a2e407", name: "İNNATAL KRİTER FORMU" },
        { id: "b6343296-26b3-4dfd-a641-16d199b69ef7", name: "LOHUSA KRİTER FORMU" },
        { id: "b43070f6-c05e-4cc6-8af6-590e963dc8e0", name: "YENİDOĞAN KRİTER FORMU" },
        { id: "15f1f7cf-22fb-4c70-8a5c-d76c33fd2400", name: "NORMAL GEBELİK KRİTER FORMU" },
        { id: "cd7b582e-67d0-478f-45a8-08de941059d3", name: "RİSKLİ GEBELİK KRİTER FORMU" },
      ],
      formSavedId: null,
      filters: {
        formIds: [], // Örn: 'd3b07384-d113-49cd-a5d6-8ee0315a1a12'
        no: ''      // Öğrenci veya personel numarası
      },
      metaData: {
        formname: '',
        loginGiris: false,
        onaylama: false,
        groupName: ''
      },
formInfo:{id:"",date:""},
      onayDurums: [],
      tableRows: [],
      extraGroupData: [], // Controller'dan dönen "data" listesi (Grup onay raporları)
      headers: [
        { text: 'Profil', value: 'resim', sortable: false, width: '70px' },
        { text: 'Kullanıcı Bilgisi', value: 'username' },
        { text: 'Kayıt Tarihi', value: 'date' },
        { text: 'Durum', value: 'onayName', alignment: 'center' },
        { text: 'İşlemi Yapan', value: 'onaylayanName' },
        { text: 'Red Nedeni', value: 'ReddedilmeNedeni', sortable: false },
        { text: 'İşlemler', value: 'actions', sortable: false, align: 'end' }
      ],
      ogrenciBilgileri: []
    };
  },
  created() {
    this.dataBind();
  },
  computed: {
    criteria() {
      if (this.filters.no && this.tableRows.length > 0) {
        return this.ogrenciBilgileri.map(m => ({ // 👈 Buraya parantez ekledik
          label: m.name,
          count: m.rapor.find(x => x.onayDurumId == 3)?.count ?? 0
        }));
      }
      else
        return [];
    },
    studentInfo() {



      if (this.filters.no && this.tableRows.length > 0) {
        let row = this.tableRows[0];
        if (row) {
          return {
            kullaniciId:row.kullaniciId,
            name: row.username2,
            number: row.username,
            advisor: row.danisman
            
          }
        }
        else {
          return {
            name: 'ggdfg',
            number: '180825218',
            advisor: ''
          };
        }



      }
      else {
        return {
          name: 'ggdfg',
          number: '180825218',
          advisor: ''
        };
      }
    }
  },
  methods: {
raporAl(){
FormService.EbelikOnayFormuAl(this.filters.no).then((result) => {
  this.formInfo=result.data;
  this.frmReport=true;
}).catch((err) => {
  this.$toast.warning("Form alınması esnasında hata oluşmaktadır.")
});
},
    excelAktar() {
      // console.log("object,", document.getElementById("tblFormDataHeader").parentElement);
      // let outTable = document.getElementsByClassName("v-data-table__wrapper");
      // console.log("outTable", outTable);
      // let table = outTable[0].querySelector("table");
      let table = document.getElementsByClassName("form-container")[0];
      // tableToExcel("tblFormData", this.result.formname);
      const excelStilleri = `
  table { border-collapse: collapse; }
td { border: 1px solid black;text-align:center;  padding: 4px 8px;  }
th { border: 1px solid black;text-align:left; }
`;
      tableToExcel(table, "ssdfsdf", excelStilleri);
    },
    async fetchData() {
      if (!this.$refs.filterForm.validate()) return;

      this.loading = true;
      this.tableRows = [];      // Eski verileri temizle
      this.loadedForms = [];    // Eski form başlıklarını temizle

      try {
        // Seçilen her bir Form ID için sırayla aynı API'ye istek atıyoruz
        for (const id of this.filters.formIds) {
          const response = await axios.get('/api/Form/Data2/' + id, {
            params: {

              no: this.filters.no || null
            }
          });

          const resData = response.data;
          console.log("resData:", resData);
          if (resData) {
            // Çekilen formun adını üst listeye ekle
            // if (resData.formname && !this.loadedForms.includes(resData.formname)) {
            //   this.loadedForms.push(resData.formname);
            // }
            if (this.filters.no) {

              this.ogrenciBilgileri = resData.data;
            }



            // Gelen satırlara "belongingFormName" (Ait olduğu form adı) mülkünü ekleyip ana listeyle birleştiriyoruz
            if (resData.rows && resData.rows.length > 0) {
              const mappedRows = resData.rows.map(row => ({
                ...row,
                belongingFormName: resData.formname // Tabloda ayırt edebilmek için ekledik
              }));

              // this.tableRows.push(...resData.rows);
              this.tableRows.push(...mappedRows);
              console.log("resData2:", this.tableRows);
            }
          }
        }
      } catch (error) {
        console.error("Veriler çekilirken bir hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    },
    // async fetchData() {
    //   if (!this.$refs.filterForm.validate()) return;

    //   this.loading = true;
    //   try {
    //     // Backend API adresinizi buraya göre güncelleyin.
    //     // Örn: /api/Form/Data2
    //     const response = await axios.get('/api/Form/Data2/'+this.filters.formId, {
    //       params: {

    //         no: this.filters.no || null
    //       }
    //     });

    //     const resData = response.data;

    //     // Üst bilgileri set edelim
    //     this.metaData = {
    //       formname: resData.formname,
    //       loginGiris: resData.loginGiris,
    //       onaylama: resData.onaylama,
    //       groupName: resData.groupName
    //     };

    //     // Tablo satırlarını set edelim (Backend'deki `rows: list` alanı)
    //     this.tableRows = resData.rows || [];

    //     // Eğer gruptan gelen ekstra rapor verileri varsa buraya kaydedilir
    //     this.extraGroupData = resData.data || [];

    //   } catch (error) {
    //     console.error("Veri çekilirken bir hata oluştu:", error);
    //     // Burada kullanıcıya toast/alert ile hata gösterebilirsiniz.
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // OnayDurumId'ye göre dinamik renk belirleme fonksiyonu
    getStatusColor(statusId) {
      console.log("getStatusColor:", statusId);
      switch (statusId) {
        case 1: return 'warning';  // Beklemede / İşlem Yapılmadı
        case 2: return 'warning';  // Beklemede / İşlem Yapılmadı
        case 3: return 'success';  // Onaylandı
        case 4: return 'error';    // Reddedildi
        case 5: return 'error';    // Reddedildi
        default: return 'grey';
      }
    },
    viewDetail(item) {
      this.formSavedId = item.formSavedId;
      this.dgKolanlarıGoster = true;
      // Satır detayına tıklandığında yapılacak işlem (Örn: modal açıp formSavedId basmak)
      //alert(`Form Kayıt ID: ${item.formSavedId} detayları başarıyla getirildi.`);
    }
    ,
    dataBind() {
      OnayDurumService.listOnayDurums().then((result) => {
        this.onayDurums = result.data;
      }).catch((err) => {

      });
    },
    btnOnaylamaIslemKaydet() {

      console.log("this.SElectedItem:", this.selectedItem);
      if (this.selectedOnayDurumId) {
        let reddedilmeNedeni = "";
        //if (this.selectedOnayDurumId==4 ) {
        if ([4, 5].includes(this.selectedOnayDurumId)) {
          let value = prompt('Reddedilme Nedeni Giriniz',);
          // console.log("Prompt:", value);
          if (value == null) {
            return false;
          }
          else {
            reddedilmeNedeni = value;
          }

        }

        //this.$toast.warning("Onay Durumu boş bırakılamaz."+value)
        FormService.onaylama(this.formSavedId, { onayDurumId: this.selectedOnayDurumId, onayDurumSebeb: reddedilmeNedeni }).then((result) => {

          this.$toast.success("İşleminiz başarılı bir şekilde gerçekleştirilmiştir.");
          this.dgKolanlarıGoster = false;
          this.fetchData();
        }).catch((err) => {

        });
      }
      else {
        this.$toast.warning("Onay Durumu boş bırakılamaz.")
      }

    },
  }
};
</script>

<style scoped>
/* İsteğe bağlı özel CSS düzenlemeleri */
.v-card-title {
  font-size: 1.1rem !important;
}

.table-container {
  padding: 20px;
  font-family: sans-serif;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

th {
  background-color: #f4f6f9;
  color: #333;
}

.font-bold {
  font-weight: bold;
}

.text-muted {
  color: #888;
  font-style: italic;
}

/* Durum Rozetleri (Badges) */
.status-pending {
  background-color: #fef3c7;
  color: #d97706;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9em;
}

.status-approved {
  background-color: #d1fae5;
  color: #059669;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9em;
}
</style>